import { getElement, resetForm, setSelect2Ajax } from "../../../../../helpers";

let FormRole;

export const storeRole = () => {
    FormRole = document.querySelector("#formRole");

    FormRole.elements.save.addEventListener("click", () => {
        if (FormRole.reportValidity()) {
            FormRole.submit();
        }
    });
};

export const create = (url, title) => {
    resetForm("formRole", title, url);
};

export const edit = (url, title, data) => {
    data = JSON.parse(atob(data));
    resetForm("formRole", title, url);
    FormRole.elements.name.value = data.name;
    FormRole.elements.description.value = data.description;
};
